﻿export function isPacificDaylightTime(date: Date) {
  // US DST rules: Starts second Sunday in March, ends first Sunday in November
  const year = date.getFullYear()

  // Calculate second Sunday in March
  const marchStart = new Date(year, 2, 8) // March 8th
  const daysUntilSundayInMarch = (7 - marchStart.getDay()) % 7
  const dstStart = new Date(year, 2, 8 + daysUntilSundayInMarch)
  dstStart.setHours(2, 0, 0, 0) // 2am local time

  // Calculate first Sunday in November
  const novemberStart = new Date(year, 10, 1) // November 1st
  const daysUntilSundayInNov = (7 - novemberStart.getDay()) % 7
  const dstEnd = new Date(year, 10, 1 + daysUntilSundayInNov)
  dstEnd.setHours(2, 0, 0, 0) // 2am local time

  // Compare with current date
  return date >= dstStart && date < dstEnd
}
